import React from "react";
import { useParams } from "react-router-dom";
import {
  apiCallPost,
  calculateCost,
  indianRupee,
  niceDate,
} from "../util/util";
import "../Discharge.css";
import {
  Button,
  ControlGroup,
  InputGroup,
  NonIdealState,
  NumericInput,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import _ from "lodash";
import Barcode from "react-barcode";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class LabelLower extends React.Component {
  state = {
    isLoading: true,
    isFailure: false,
    rnId: null,
    hasLoaded: false,
    showTable: false,
    pageHeight: 297,
    pageWidth: 210,
    pageMargin: 4,
    labelHeight: 27.5,
    labelWidth: 66.5,
    labelMargin: 1,
    skipBox: 0,
  };
  componentDidMount() {
    let ss = this.props.params.rnId;
    this.setState({ rnId: ss });
    if (ss) {
      this.getItems(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getItems = async (ss) => {
    try {
      let res = await apiCallPost("/print/receiptNote/itemListForTags", {
        _id: this.props.params.rnId,
      });
      let ll = res.map((each) => {
        return {
          ...each,
          numLabels:
            each.itemInfo.quantity / each.itemInfo.subunitOfConsumption,
          hasPrint: true,
        };
      });
      this.setState({ isLoading: false, hasLoaded: true, loadedItems: ll });
    } catch (err) {
      cogoToast.error("Failed to load items.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };
  renderEachLoadedItem = () => {
    if (!this.state.loadedItems) {
      return null;
    }
    if (!this.state.loadedItems.length) {
      return null;
    }
    let ll = this.state.loadedItems;

    return ll.map((each, index) => {
      return (
        <tr>
          <td minimal large>
            {each.itemInfo.itemName}
          </td>
          <td minimal large>
            {each.itemInfo.quantity / each.itemInfo.subunitOfConsumption}
          </td>
          <td minimal large>
            {each.itemInfo.serialNumber}
          </td>

          <td minimal large>
            {each.itemInfo.itemHasExpiry ? (
              <> {niceDate(each.itemInfo.expiresOn)}</>
            ) : (
              "NA"
            )}
          </td>

          <td minimal large>
            {each.itemInfo.itemCanBeSold ? (
              <>{indianRupee(each.itemInfo.itemSalePrice)}</>
            ) : (
              "NA"
            )}
          </td>
          <td minimal large>
            {each.itemInfo.itemCanBeSold ? (
              <>{each.itemInfo.itemSalePriceGst} %</>
            ) : (
              "NA"
            )}
          </td>
          {/* <td minimal large>
            {indianRupee(
              each.roundOffAmountPaise -
                calculateCost(
                  each.itemInfo.itemSalePrice,
                  each.itemInfo.itemSalePriceGst,
                  1,
                  1
                )
            )}
          </td> */}
          <td minimal large>
            {each.itemInfo.itemCanBeSold ? (
              <>
                {indianRupee(
                  calculateCost(
                    each.itemInfo.itemSalePrice,
                    each.itemInfo.itemSalePriceGst,
                    1,
                    1
                  )
                )}
              </>
            ) : (
              "NA"
            )}
          </td>
          <td>
            <Button
              text={each.hasPrint ? "Print" : "Don't Print"}
              intent={each.hasPrint ? "success" : "danger"}
              onClick={() => {
                let ll = this.state.loadedItems;

                ll[index].numLabels = each.hasPrint
                  ? 0
                  : each.itemInfo.quantity / each.itemInfo.subunitOfConsumption;
                ll[index].hasPrint = !each.hasPrint;
                this.setState({ loadedItems: ll });
              }}
            />
          </td>
          <td>
            <NumericInput
              min={0}
              max={each.itemInfo.quantity / each.itemInfo.subunitOfConsumption}
              clampValueOnBlur
              buttonPosition="NONE"
              value={each.numLabels}
              onValueChange={(num) => {
                let ll = this.state.loadedItems;
                ll[index].numLabels = num;
                this.setState({ loadedItems: ll });
              }}
            />
          </td>
        </tr>
      );
    });
  };
  renderLoadedItemsForScreen = () => {
    if (!this.state.loadedItems) {
      return null;
    }
    if (!this.state.loadedItems.length) {
      return null;
    }
    return (
      <div style={{ marginTop: "20px" }}>
        <div>{this.renderHorizontalText("ITEMS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Serial/Batch</th>
              <th>Expiry Date</th>
              <th>Sale Price</th>
              <th>Sale GST</th>
              {/* <th>Round Off</th> */}
              <th>Total Price</th>
              <th>Print?</th>
              <th># of Labels To Print</th>
            </tr>
          </thead>
          <tbody>{this.renderEachLoadedItem()}</tbody>
        </table>
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "large",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderPrintDimensions = () => {
    return (
      <div style={{ margin: "50px" }}>
        {this.renderHorizontalText("PRINT DIMENSIONS")}
        <br />
        <ControlGroup>
          {" "}
          <Tag large minimal>
            Label Width
          </Tag>
          <InputGroup
            value={this.state.labelWidth}
            onChange={(event) => {
              this.setState({ labelWidth: event.target.value });
            }}
          />
          <Tag large minimal>
            Label Height
          </Tag>
          <InputGroup
            value={this.state.labelHeight}
            onChange={(event) => {
              this.setState({ labelHeight: event.target.value });
            }}
          />
          <Tag large minimal>
            Label Margin
          </Tag>
          <InputGroup
            value={this.state.labelMargin}
            onChange={(event) => {
              this.setState({ labelMargin: event.target.value });
            }}
          />
        </ControlGroup>
        <ControlGroup>
          <Tag large minimal>
            Page Width
          </Tag>
          <InputGroup
            value={this.state.pageWidth}
            onChange={(event) => {
              this.setState({ pageWidth: event.target.value });
            }}
          />{" "}
          <Tag large minimal>
            Page Height
          </Tag>
          <InputGroup
            value={this.state.pageHeight}
            onChange={(event) => {
              this.setState({ pageHeight: event.target.value });
            }}
          />
          <Tag large minimal>
            Page Margin
          </Tag>
          <InputGroup
            value={this.state.pageMargin}
            onChange={(event) => {
              this.setState({ pageMargin: event.target.value });
            }}
          />
        </ControlGroup>

        <ControlGroup>
          {this.calculateBoxes().error ? (
            <Tag large minimal>
              {this.calculateBoxes().message}
            </Tag>
          ) : (
            <Tag large minimal>
              {this.calculateBoxes().rows} rows x {this.calculateBoxes().cols}{" "}
              cols -- For {this.calculateBoxes().labels} labels, you will need{" "}
              {this.calculateBoxes().pages} pages
            </Tag>
          )}
        </ControlGroup>
        <ControlGroup>
          <Tag large minimal>
            # of Boxes To Skip From Beginning
          </Tag>
          <InputGroup
            value={this.state.skipBox}
            onChange={(event) => {
              this.setState({ skipBox: event.target.value });
            }}
          />{" "}
        </ControlGroup>
      </div>
    );
  };
  calculateBoxes = () => {
    if (!this.state.pageHeight) {
      return { error: true, message: "Please enter all values" };
    }
    if (!this.state.pageWidth) {
      return { error: true, message: "Please enter all values" };
    }
    if (!this.state.labelHeight) {
      return { error: true, message: "Please enter all values" };
    }
    if (!this.state.labelWidth) {
      return { error: true, message: "Please enter all values" };
    }
    if (!this.state.pageMargin) {
      return { error: true, message: "Please enter all values" };
    }
    let pageHeight = parseFloat(this.state.pageHeight);
    let pageWidth = parseFloat(this.state.pageWidth);
    let labelHeight = parseFloat(this.state.labelHeight);
    let labelWidth = parseFloat(this.state.labelWidth);
    let pageMargin = parseFloat(this.state.pageMargin);
    let numLabelRows = Math.floor((pageHeight - 2 * pageMargin) / labelHeight);
    let numLabelCols = Math.floor((pageWidth - 2 * pageMargin) / labelWidth);

    let totalLabelsToPrint = _.sum(
      this.state.loadedItems.map((each) => each.numLabels)
    );
    let eachPage = numLabelRows * numLabelCols;
    let numPages = Math.ceil(totalLabelsToPrint / eachPage);

    return {
      rows: numLabelRows,
      cols: numLabelCols,
      labels: totalLabelsToPrint,
      pages: numPages,
      error: false,
    };
  };
  renderPrintArea = () => {
    if (this.calculateBoxes().error) {
      return null;
    }
    let { rows } = this.calculateBoxes();
    let { labelHeight } = this.state;
    let itemsToPrint = this.state.loadedItems.filter((x) => x.hasPrint);
    let printList = [];
    for (var i = 0; i < itemsToPrint.length; i++) {
      for (var j = 0; j < itemsToPrint[i].numLabels; j++) {
        printList.push(itemsToPrint[i].itemInfo);
      }
    }
    let skipBox = this.state.skipBox;
    if (skipBox) {
      for (i = 0; i < skipBox; i++) {
        printList.unshift({
          itemSkip: true,
        });
      }
    }
    let totalHeightOfBoxes = rows * labelHeight;
    let { pageHeight, pageMargin } = this.state;
    let totalHeightOfPage = pageHeight - 2 * pageMargin;
    let spaceLeft = totalHeightOfPage - totalHeightOfBoxes;

    let marginBottom = spaceLeft / (rows - 1);

    const combinedItemName = (it) => {
      let name = it.itemName
        .replaceAll("- Frame", "")
        .replaceAll("- frame", "");
      let price = it.itemCanBeSold
        ? indianRupee(
            calculateCost(it.itemSalePrice, it.itemSalePriceGst, 1, 1),
            0
          )
        : "";
      return `${name} | ${price}`;
    };

    return printList.map((each) => {
      return (
        <div
          style={{
            backgroundColor: "yellow",
            height: `${this.state.labelHeight}mm`,
            width: `${this.state.labelWidth}mm`,
            marginRight: `${this.state.labelMargin}mm`,
            marginBottom: `${marginBottom}mm`,
            boxSizing: "border-box",
            padding: "2mm",
            pageBreakInside: "avoid",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <>
            {each.itemSkip ? null : (
              <>
                <div style={{ fontSize: "xx-small" }}>
                  {combinedItemName(each)}
                </div>

                <ControlGroup>
                  {each.itemHasExpiry ? (
                    <div style={{ fontSize: "xx-small" }}>
                      Expiry Date: {niceDate(each.expiresOn)} |
                    </div>
                  ) : null}
                  {/* {each.itemCanBeSold ? (
                    <div style={{ fontSize: "xx-small" }}>
                      Price:{" "}
                      {indianRupee(
                        calculateCost(
                          each.itemSalePrice,
                          each.itemSalePriceGst,
                          1,
                          1
                        ),
                        0
                      )}
                    </div>
                  ) : null} */}
                </ControlGroup>
                <Barcode
                  value={each.serialNumber}
                  width={1}
                  height={40}
                  fontSize={9}
                  textMargin={1}
                  margin={1}
                  displayValue={true}
                />
              </>
            )}
          </>
        </div>
      );
    });
  };
  renderPrintTable = () => {
    if (this.calculateBoxes().error) {
      return null;
    }
    let { rows } = this.calculateBoxes();
    let { cols } = this.calculateBoxes();
    let { pages } = this.calculateBoxes();
    let { labelHeight } = this.state;
    let itemsToPrint = this.state.loadedItems.filter((x) => x.hasPrint);
    let printList = [];
    for (var i = 0; i < itemsToPrint.length; i++) {
      for (var j = 0; j < itemsToPrint[i].numLabels; j++) {
        printList.push(itemsToPrint[i].itemInfo);
      }
    }
    let skipBox = this.state.skipBox;
    if (skipBox) {
      for (i = 0; i < skipBox; i++) {
        printList.unshift({
          itemSkip: true,
        });
      }
    }
    let tablePages = [];
    for (i = 0; i < pages; i++) {
      let tableRows = [];
      for (j = 0; j < rows; j++) {
        let row = [];
        for (var k = 0; k < cols; k++) {
          let each = printList[i * rows * cols + j * cols + k];
          if (each !== undefined) {
            row.push(printList[i * rows * cols + j * cols + k]);
          }
        }
        if (row.length) {
          tableRows.push(row);
        }
      }
      tablePages.push(tableRows);
    }

    let totalHeightOfBoxes = rows * labelHeight;
    let { pageHeight, pageMargin } = this.state;
    let totalHeightOfPage = pageHeight - 2 * pageMargin;
    let spaceLeft = totalHeightOfPage - totalHeightOfBoxes;

    let marginBottom = spaceLeft / (rows - 1);
    return tablePages.map((eachPage) => {
      return (
        <table style={{ pageBreakInside: "avoid" }}>
          {eachPage.map((eachRow) => {
            return (
              <tr>
                {eachRow.map((each) => {
                  return (
                    <td
                      style={{
                        height: `${this.state.labelHeight}mm`,
                        width: `${this.state.labelWidth}mm`,
                        marginRight: `${this.state.labelMargin}mm`,
                        marginBottom: `${marginBottom}mm`,
                        border: "none",
                        boxSizing: "border-box",
                        padding: "2mm",
                        pageBreakInside: "avoid",
                        textAlign: "center",
                      }}
                    >
                      <>
                        {each.itemSkip ? null : (
                          <>
                            <b>{each.itemName}</b>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {each.itemHasExpiry ? (
                                <div style={{ fontSize: "smaller" }}>
                                  ◼Expiry Date: {niceDate(each.expiresOn)}
                                </div>
                              ) : null}
                              {each.itemCanBeSold ? (
                                <div style={{ fontSize: "smaller" }}>
                                  ◼Price:{" "}
                                  {indianRupee(
                                    calculateCost(
                                      each.itemSalePrice,
                                      each.itemSalePriceGst,
                                      1,
                                      1
                                    ),
                                    0
                                  )}
                                </div>
                              ) : null}
                            </div>
                            <Barcode
                              value={each.serialNumber}
                              width={1}
                              height={40}
                              fontSize={9}
                              textMargin={1}
                              margin={1}
                              displayValue={true}
                            />
                          </>
                        )}
                      </>
                    </td>
                  );
                })}
              </tr>
            );
          })}

          {/*  {eachPage.map((eachRow) => {
            return (
              <tr style={{ pageBreakInside: "avoid" }}>
                {eachRow.map((each) => {
                  return (
                    <td
                      style={{
                        backgroundColor: "yellow",
                        height: `${this.state.labelHeight}mm`,
                        width: `${this.state.labelWidth}mm`,
                        marginRight: `${this.state.labelMargin}mm`,
                        marginBottom: `${marginBottom}mm`,
                        boxSizing: "border-box",
                        padding: "2mm",
                        pageBreakInside: "avoid",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <>
                        {each.itemSkip ? null : (
                          <>
                            <b>{each.itemName}</b>

                            <ControlGroup>
                              {each.itemHasExpiry ? (
                                <div style={{ fontSize: "smaller" }}>
                                  Expiry Date: {niceDate(each.expiresOn)} |
                                </div>
                              ) : null}
                              {each.itemCanBeSold ? (
                                <div style={{ fontSize: "smaller" }}>
                                  Price:{" "}
                                  {indianRupee(
                                    calculateCost(
                                      each.itemSalePrice,
                                      each.itemSalePriceGst,
                                      1,
                                      1
                                    ),
                                    0
                                  )}
                                </div>
                              ) : null}
                            </ControlGroup>
                            <Barcode
                              value={each.serialNumber}
                              width={1}
                              height={40}
                              fontSize={9}
                              textMargin={1}
                              margin={1}
                              displayValue={true}
                            />
                          </>
                        )}
                      </>
                    </td>
                  );
                })}
              </tr>
            );
          })} */}
        </table>
      );
    });
    /*  return printList.map((each) => {
      return (
        <div
          style={{
            backgroundColor: "yellow",
            height: `${this.state.labelHeight}mm`,
            width: `${this.state.labelWidth}mm`,
            marginRight: `${this.state.labelMargin}mm`,
            marginBottom: `${marginBottom}mm`,
            boxSizing: "border-box",
            padding: "2mm",
            pageBreakInside: "avoid",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <>
            {each.itemSkip ? null : (
              <>
                <b>{each.itemName}</b>

                <ControlGroup>
                  {each.itemHasExpiry ? (
                    <div style={{ fontSize: "smaller" }}>
                      Expiry Date: {niceDate(each.expiresOn)} |
                    </div>
                  ) : null}
                  {each.itemCanBeSold ? (
                    <div style={{ fontSize: "smaller" }}>
                      Price:{" "}
                      {indianRupee(
                        calculateCost(
                          each.itemSalePrice,
                          each.itemSalePriceGst,
                          1,
                          1
                        ),
                        0
                      )}
                    </div>
                  ) : null}
                </ControlGroup>
                <Barcode
                  value={each.serialNumber}
                  width={1}
                  height={40}
                  fontSize={9}
                  textMargin={1}
                  margin={1}
                  displayValue={true}
                />
              </>
            )}
          </>
        </div>
      );
    }); */
  };
  renderPrintBox = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {this.renderPrintArea()}
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.hasLoaded) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.loadedItems) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.loadedItems.length) {
      return (
        <div className="center_screen">
          <NonIdealState icon="warning-sign" title="No items found." />
        </div>
      );
    }
    let printStyleString = `@page {
    
    size: ${this.state.pageWidth}mm  
    ${this.state.pageHeight}mm 
    !important; 

    margin-top: ${this.state.pageMargin}mm !important;
    margin-left: ${this.state.pageMargin}mm !important;
    margin-bottom: ${
      this.state.pageMargin - this.state.labelMargin
    }mm !important;
    margin-right: ${
      this.state.pageMargin - this.state.labelMargin
    }mm !important;
    }
}`;
    return (
      <div>
        <style type="text/css" media="print">
          {printStyleString}
        </style>
        <div>
          <div className="no__print">
            {this.renderLoadedItemsForScreen()}
            {this.renderPrintDimensions()}
          </div>
          <div> {this.renderPrintBox()}</div>
          {/* <div>{this.renderPrintTable()}</div> */}
        </div>
      </div>
    );
  }
}

const LabelPrint = withRouter(LabelLower);
export default LabelPrint;
